module.exports = __webpack_public_path__ + "img/neckline binding width.fafc496e.png";